module.exports = __webpack_public_path__ + "img/petik-bawah.9fa9f8e2.svg";